import * as pbi from '../../public/index.component'
import { AdminService } from '../admin.service';
declare var jquery: any;
declare var $: any;
declare var ace: any;
@pbi.Component({
    selector: 'linkalias',
    templateUrl: './linkalias.component.html',
    styleUrls: ['./linkalias.component.css']
})

export class LinkAliasComponent {
    pb_func: pbi.PublicComponent = new pbi.PublicComponent();
    items: Object[];
    PageTitle: string = "Quản lý Link Alias";
    //#region LinkAlias
    Title: string = "";
    ID: string = "-1";
    Name: string = "";
    Link: string = "";
    Rewrite: string = "";
    Tags: string = "";
    MoTaNgan: string = "";
    TitleAlias: string = "";
    Active: boolean = false;
    Action: string = "";
    LinkOrg: string = "";
    //#endregion LinkAlias
    constructor(private adminService: AdminService, private router: pbi.Router) {
        adminService.openLoading0();
    }
    ngOnInit() {
        var this_sav = this;
        var editModal = $('#EditLinkAliasModal');
        this_sav.pb_func.loadScript([
            'assets/global/scripts/datatable.js',
            'assets/global/plugins/datatables/datatables.min.js',
            'assets/global/plugins/datatables/plugins/bootstrap/datatables.bootstrap.js',
            'assets/global/plugins/bootstrap-tagsinput/bootstrap-tagsinput.js',
            'assets/more/script/fixHeightContent.js'
        ], 'linkalias', function () {
            this_sav.tableLinkAlias();
        });
    };

    //#region Load Table Select
    tableLinkAlias() {
        var this_sav = this;
        var url = this_sav.pb_func.getBaseUrl() + "api/LinkAlias/load";
        var table = $('#datatable_ajax');
        
        var tbl = table.DataTable({
            "bProcessing": true,
            "bServerSide": true,
            "sAjaxSource": url,
            "bSort" : false,
            "fnServerData": function (sSource, aoData, fnCallback, oSettings) {
                oSettings.jqXHR = $.ajax({
                    "dataType": 'json',
                    "type": "POST",
                    "url": sSource,
                    "data": aoData,
                    "headers": { 'Authorization': this_sav.pb_func.getToken() },
                    "success": function(json) {
                        this_sav.items = json.aaData;
                        if (this_sav.items.length > 0) {
                            this_sav.LinkOrg = this_sav.items[0]["LinkOrg"];
                        }
                        fnCallback(json);
                    },
                });
            },
            "columns": [
                { "data": null },
                { "data": "Name" },
                { "data": "Link" },
                { "data": "Rewrite" },
                { "data": "Active" },
                { "data": "Action" }
            ],
            "lengthMenu": [
                [5],
                [5]
            ],
            "pageLength": 5,
            "drawCallback": function (settings) {
                $('.EditLinkAliasModal').off('click');
                $('.EditLinkAliasModal').click(function () {
                    this_sav.EditLinkAliasModal(this, $(this).attr('idsp'), $(this).attr('typesp'));
                });
                
                $('.ActiveLinkAliasModal').off('click');
                $('.ActiveLinkAliasModal').click(function () {
                    this_sav.Active = $(this).prop('checked');
                    this_sav.ID = $(this).attr('idsp');
                    this_sav.UpdateLinkAlias(this, $(this).attr('typesp'));
                });
            },
            "rowCallback": function (row, data, displayNum, displayIndex, dataIndex) {
                var page = this.fnPagingInfo().iPage;
                var length = this.fnPagingInfo().iLength;
                var index = (page * length + (displayIndex + 1));
                $('td:eq(0)', row).html(index);
            },
            "initComplete": function (settings, json) {
                this_sav.adminService.closeLoading(() => {

                });
            }
        });
    }
    //#endregion Load Table Select

    //#region Modal
    EditLinkAliasModal($event, ID: string, type: string) {
        var this_sav = this;
        var a = $event.currentTarget;
        if (type != 'add') {
            a = $event;
        }
        var tr = $(a).parent().parent().parent();
        this_sav.ID = ID;
        
        var editModal = $('#EditLinkAliasModal');
        if (type == "add") {
            setTimeout(() => { editModal.find('input.autofocus').focus(); }, 500);
            this_sav.Name = "";
            this_sav.Link = "";
            this_sav.Rewrite ="";
            this_sav.Tags = "";
            this_sav.MoTaNgan = "";
            this_sav.TitleAlias = "";
            this_sav.Title = "Thêm mới Alias";
        }
        else if (type == "edit") {
            setTimeout(() => { editModal.find('input.autofocus').focus(); }, 500);
            var row = this_sav.items.filter(function (item) {
                return item["ID"] == ID;
            })[0];

            this_sav.Name = row["Name"];
            this_sav.Link = row["Link"];
            this_sav.Rewrite = row["Rewrite"];
            this_sav.Tags = row["Tags"];
            this_sav.MoTaNgan = row["MoTaNgan"];
            this_sav.TitleAlias = row["TitleAlias"];
            this_sav.Title = `Sửa Alias "${this_sav.Name}"`;
        }
        else if (type == "del") {
            var row = this_sav.items.filter(function (item) {
                return item["ID"] == ID;
            })[0];
            this_sav.Name = row["Name"];
            this_sav.Title = `Xóa Alias "${this_sav.Name}"`;
        }
        
        editModal.find('.Tags').tagsinput('removeAll');
        if(this_sav.Tags == null) { this_sav.Tags = ""; }
        var tagsArr = this_sav.Tags.split(',');
        for (var i in tagsArr) {
            editModal.find('.Tags').tagsinput('add', tagsArr[i]);
        }

        this_sav.Action = type;
        this_sav.Active = false;
        $(a).next().click();
    }
    //#endregion Modal

    //#region Add, Edit, Del
    UpdateLinkAlias($event, type: string) {
        var this_sav = this;
        var table = $('#datatable_ajax').DataTable();
        var editModal = $('#EditLinkAliasModal');
        var a = $event.currentTarget;
        if(a == null)
            a = $event;

        this_sav.Link = editModal.find('.Link').val();
        this_sav.Tags = editModal.find('.Tags').tagsinput('items');

        this_sav.adminService.openLoading1();
        this_sav.pb_func.callAPI('api/LinkAlias/Update', 'POST',
            {
                ID: this_sav.ID, Name: this_sav.Name,
                Link: this_sav.Link, Rewrite: this_sav.Rewrite,
                Tags: this_sav.Tags.toString(), MoTaNgan: this_sav.MoTaNgan, 
                Active: this_sav.Active, Type: type,
                TitleAlias: this_sav.TitleAlias
            },
            null, function (status, mess) {
                this_sav.adminService.closeLoading(function () { });
                var elemNotify = editModal.find('.notifyModal');
                if(type == "updateActive") {
                    elemNotify = $;
                    if (status == 0) {
                        var checked = $(a).prop('checked');
                        $(a).prop('checked', checked !== true);
                    }
                }

                if (status == 0) {
                    elemNotify.notify(mess.toString(), { globalPosition: 'bottom right', className: 'error' });
                }
                else {
                    table.ajax.reload(null, false);
                    elemNotify.notify(mess.toString(), { globalPosition: 'bottom right', className: 'success' });
                }
            });
    }

    DeleteLinkAlias($event, type: string) {
        var this_sav = this;
        var table = $('#datatable_ajax').DataTable();
        this_sav.adminService.openLoading1();
        this_sav.pb_func.callAPI('api/LinkAlias/Delete', 'POST', { ID: this_sav.ID }, null, function (status, mess) {
            this_sav.adminService.closeLoading(function () {
                if (status == 0) {
                    $.notify(mess, { globalPosition: 'bottom right', className: 'error' });
                }
                else {
                    table.ajax.reload(null, false);
                    $.notify(mess, { globalPosition: 'bottom right', className: 'success' });
                }
                $('#DelLinkAliasModal .close').click();
            });
        });
    }
    //#endregion Add, Edit, Del

    GetLinkAlias() {
        var this_sav = this;
        if (this_sav.Action == "add") {
            this_sav.Link = '/' + this_sav.pb_func.convertToSlug(this_sav.Name);
        }
        return this_sav.Link;
    }
}


// WEBPACK FOOTER //
// ./src/app/admin/linkalias/linkalias.component.ts